module.exports = {
    EpiappClientEvent: require('./epiapp/client/EpiappClientEvent'),
    EpiappClientFollowEvent: require('./epiapp/client/EpiappClientFollowEvent'),
    EpiappClientResolveEvent: require('./epiapp/client/EpiappClientResolveEvent'),
    EpiappActivationEvent: require('./epiapp/EpiappActivationEvent'),
    EpiWebsiteEvent: require('./websites/epi/EpiWebsiteEvent'),
    EpiarcWebsiteEvent: require('./websites/epiarc/EpiarcWebsiteEvent'),
    LaunchblogEvent: require('./websites/launchblog/LaunchblogEvent'),
    Streamer: require('./Streamer')
}
